import CryptoJS from 'crypto-js'
export const encrypt = function(word){
    let key = CryptoJS.enc.Utf8.parse("88YQZH139892TNWM");
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return encrypted.toString();
};
export const getArrName = function(status, list){
    for (let i = 0; i < list.length; i++) {
        if (status.toString() == list[i].value) {
            return list[i].dictName;
        }
    }
};
export const getPaymentName = function(status, list){
    for (let i = 0; i < list.length; i++) {
        if (status.toString() == list[i].value) {
            return list[i].dictName;
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/md5.js